import { withInstall } from "@element-customer-plus/utils"
import Teleport from "./src/teleport.vue"
import type { SFCWithInstall } from "@element-customer-plus/utils"

export const ElTeleport: SFCWithInstall<typeof Teleport> = withInstall(Teleport)

export default ElTeleport

export * from "./src/teleport"
